import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchOrderById, fetchOrderItemsByOrderId } from "../../../redux-toolkit/order/order-thunks";
import {
  selectOrder,
  selectOrderItems,
  selectIsOrderLoading,
} from "../../../redux-toolkit/order/order-selector";
import Spinner from "../../../components/Spinner/Spinner";
import "./InvoicePage.css";

const InvoicePage = () => {
  const dispatch = useDispatch();
  const params = useParams<{ id: string }>();

  const order = useSelector(selectOrder);
  const items = useSelector(selectOrderItems);
  const loading = useSelector(selectIsOrderLoading);

  useEffect(() => {
    dispatch(fetchOrderById(params.id));
    dispatch(fetchOrderItemsByOrderId(params.id));
  }, [dispatch, params.id]);

  useEffect(() => {
    if (!loading) {
      setTimeout(() => window.print(), 500);
    }
  }, [loading]);

  if (loading) return <Spinner />;

  return (
    <div className="invoice-container">

      <h1 className="invoice-title">Dropkart Invoice</h1>

      <div className="invoice-header">
        <div>
          <p><b>Order ID:</b> #{order.id}</p>
          <p><b>Date:</b> {order.date}</p>
        </div>

        <div>
          <p><b>Customer:</b> {order.firstName} {order.lastName}</p>
          <p><b>Email:</b> {order.email}</p>
          <p><b>Phone:</b> {order.phoneNumber}</p>
        </div>
      </div>

      <h3 className="section-title">Shipping Address</h3>
      <p>{order.address}</p>
      <p>{order.city} - {order.postIndex}</p>

      <h3 className="section-title">Payment</h3>
      <p><b>Payment Type:</b> {order.paymentType}</p>
      <p><b>Transaction ID:</b> {order.transactionId || "-"}</p>

      <h3 className="section-title">Order Items</h3>

      <table className="invoice-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Item</th>
            <th>Brand</th>
            <th>Qty</th>
            <th>Price (₹)</th>
            <th>Total (₹)</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item, index) => (
            <tr key={index}>
              <td>{item.id}</td>
              <td>{item.perfume.perfumeTitle}</td>
              <td>{item.perfume.brand}</td>
              <td>{item.quantity}</td>
              <td>{item.perfume.price}</td>
              <td>{item.amount}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h2 className="invoice-total">Grand Total: ₹{order.totalPrice}</h2>

      <p className="thanks-msg">Thank you for shopping with Dropkart!</p>
    </div>
  );
};

export default InvoicePage;
